import fields, {
  FieldName,
  TRANSPORT_ORDER_PLACEHOLDER,
} from "@/components/custom/AlternativeTransportation/Transportations/ManualTransports/ManualTransportInput/fields";
import Field from "@/core/components/Field";
import React, { useEffect } from "react";
import {
  DATETIME_VALIDATION_KEY,
  DISABLE_FUTURE_DATES_KEY,
} from "@/core/utils/dateTimeValidations";
import { useFormContext } from "react-hook-form";
import { MANUAL_TRANSPORTS_FIELD_KEY } from "@/components/custom/AlternativeTransportation/Transportations/ManualTransports/ManualTransportInput/ManualTransportInput";
import { deepClone } from "@/core/utils";

interface TransportInputFieldProps {
  fieldName: FieldName;
  transportOrder: number;
  disableFutureDates?: boolean;
  defaultValue?: string;
}

const TransportInputField = ({
  fieldName,
  transportOrder,
  disableFutureDates,
  defaultValue,
}: TransportInputFieldProps) => {
  const { setValue } = useFormContext();

  const uniqueFieldKey = `${MANUAL_TRANSPORTS_FIELD_KEY}[${transportOrder}].${fieldName}`;
  const field = { ...fields[fieldName], key: uniqueFieldKey };
  const fieldDefaultValue = defaultValue ?? field.defaultValue;

  // Adjusting datetime validations to consider current transport order
  let updatedProperties: any = deepClone(field.properties);
  Object.entries(field.properties).forEach(([key, value]) => {
    if (key.startsWith(DATETIME_VALIDATION_KEY)) {
      updatedProperties[key] = value.replace(
        TRANSPORT_ORDER_PLACEHOLDER,
        transportOrder
      );
    }

    if (key.startsWith(DISABLE_FUTURE_DATES_KEY)) {
      updatedProperties[key] = disableFutureDates ? disableFutureDates : value;
    }
  });

  useEffect(() => {
    if (field.validate) {
      setValue(uniqueFieldKey, null);
    }
  }, []);

  return (
    <>
      <Field
        field={{
          ...field,
          properties: { ...updatedProperties, errorTranslationKey: fieldName },
          defaultValue: fieldDefaultValue,
        }}
      />
    </>
  );
};

export default TransportInputField;
